import React from 'react';
import { BiCollapse, BiExpand, BiLayer, BiLayerPlus, BiLayerMinus, BiDownload, BiCartAdd } from 'react-icons/bi';
import './FloatingButtonGroup.css';

const FloatingButtonGroup = ({
  isButtonGroupCollapsed,
  onToggleCollapse,
  onDownloadDesign,
  onAddToCart,
  onMoveLayerUp,
  onMoveLayerDown,
  onManageLayers,
  onToggleHintLayer,
  isMobile
}) => {
  const buttonSize = isMobile ? 28 : 32;
  const iconSize = isMobile ? 14 : 16;
  const buttonStyle = {
    width: `${buttonSize}px`,
    height: `${buttonSize}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
    borderRadius: '6px',
    border: '1px solid #e2e8f0',
    background: 'white',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
  };

  const buttonHoverStyle = {
    ...buttonStyle,
    background: '#f8fafc',
    transform: 'translateY(-1px)',
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
  };

  return (
    <div className="floating-button-group">
      <button 
        className="collapse-toggle"
        onClick={onToggleCollapse}
        style={isButtonGroupCollapsed ? buttonStyle : buttonHoverStyle}
        aria-label={isButtonGroupCollapsed ? 'Expand tools' : 'Collapse tools'}
      >
        {isButtonGroupCollapsed ? <BiExpand size={iconSize} /> : <BiCollapse size={iconSize} />}
      </button>
      
      {!isButtonGroupCollapsed && (
        <>
          <button 
            onClick={onDownloadDesign}
            style={buttonStyle}
            onMouseEnter={(e) => (e.currentTarget.style = buttonHoverStyle)}
            onMouseLeave={(e) => (e.currentTarget.style = buttonStyle)}
            aria-label="Download design"
          >
            <BiDownload size={iconSize} />
          </button>
          
          <button 
            onClick={onAddToCart}
            style={buttonStyle}
            onMouseEnter={(e) => (e.currentTarget.style = buttonHoverStyle)}
            onMouseLeave={(e) => (e.currentTarget.style = buttonStyle)}
            aria-label="Add to cart"
          >
            <BiCartAdd size={iconSize} />
          </button>
          
          <div style={{ width: '100%', height: '1px', background: '#e2e8f0', margin: '4px 0' }} />
          
          <button 
            onClick={onMoveLayerUp}
            style={buttonStyle}
            onMouseEnter={(e) => (e.currentTarget.style = buttonHoverStyle)}
            onMouseLeave={(e) => (e.currentTarget.style = buttonStyle)}
            aria-label="Move layer up"
          >
            <BiLayerPlus size={iconSize} />
          </button>
          
          <button 
            onClick={onMoveLayerDown}
            style={buttonStyle}
            onMouseEnter={(e) => (e.currentTarget.style = buttonHoverStyle)}
            onMouseLeave={(e) => (e.currentTarget.style = buttonStyle)}
            aria-label="Move layer down"
          >
            <BiLayerMinus size={iconSize} />
          </button>
          
          <button 
            onClick={onManageLayers}
            style={buttonStyle}
            onMouseEnter={(e) => (e.currentTarget.style = buttonHoverStyle)}
            onMouseLeave={(e) => (e.currentTarget.style = buttonStyle)}
            aria-label="Manage layers"
          >
            <BiLayer size={iconSize} />
          </button>

          <button 
            onClick={onToggleHintLayer}
            style={buttonStyle}
            onMouseEnter={(e) => (e.currentTarget.style = buttonHoverStyle)}
            onMouseLeave={(e) => (e.currentTarget.style = buttonStyle)}
            aria-label="Toggle hint layer"
          >
            <BiLayer size={iconSize} />
          </button>
        </>
      )}
    </div>
  );
};

export default FloatingButtonGroup;
